export default __webpack_public_path__ + "static/media/vistara.9e076750.png";